// contexts/CurrencyContext.js
import React, { createContext, useState, useContext } from 'react';

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState('THB');
  const [exchangeRates, setExchangeRates] = useState({
    THB: 1,
    USD: 0.027,  // 1 THB = 0.027 USD (около 37 THB за 1 USD)
    EUR: 0.025   // 1 THB = 0.025 EUR (около 40 THB за 1 EUR)
  });

  // Функция для конвертации цены с округлением
  const convertPrice = (priceInTHB) => {
    const rate = exchangeRates[currency];
    const converted = priceInTHB * rate;
    
    // Разное округление для разных валют
    if (currency === 'THB') {
      // Для батов - целые числа, кратные 50
      return Math.round(converted / 50) * 50;
    } else {
      // Для USD и EUR - до 2 знаков после запятой
      return Math.round(converted * 100) / 100;
    }
  };

  // Функция для получения символа валюты
  const getCurrencySymbol = () => {
    switch (currency) {
      case 'USD': return '$';
      case 'EUR': return '€';
      default: return '฿';
    }
  };

  // Функция для форматирования цены с красивым выводом
  const formatPrice = (priceInTHB) => {
    const convertedPrice = convertPrice(priceInTHB);
    const symbol = getCurrencySymbol();
    
    // Для батов показываем целое число без десятичных
    if (currency === 'THB') {
      return `${convertedPrice.toLocaleString()} ${symbol}`;
    }
    
    // Для USD и EUR показываем 2 знака после запятой
    return `${convertedPrice.toFixed(2)} ${symbol}`;
  };

  // Функция для получения суффикса цены
  const getPriceSuffix = () => {
    return '/day';
  };

  // Функция для получения названия валюты
  const getCurrencyName = () => {
    switch (currency) {
      case 'USD': return 'USD ($)';
      case 'EUR': return 'EUR (€)';
      default: return 'THB (฿)';
    }
  };

  // Функция для форматирования цены без суффикса (только число и символ)
  const formatPriceOnly = (priceInTHB) => {
    const convertedPrice = convertPrice(priceInTHB);
    const symbol = getCurrencySymbol();
    
    if (currency === 'THB') {
      return `${convertedPrice.toLocaleString()}${symbol}`;
    }
    
    return `${convertedPrice.toFixed(2)}${symbol}`;
  };

  return (
    <CurrencyContext.Provider value={{
      currency,
      setCurrency,
      convertPrice,
      formatPrice,
      formatPriceOnly,
      getCurrencySymbol,
      getPriceSuffix,
      getCurrencyName,
      exchangeRates
    }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);